// Variables
import variablesStyling from './theme/variables';
import colorsStyling from './theme/colors';

// Styling
import { ThemeProvider } from 'styled-components';
import { BodyStyled, SiteWrapperStyled } from './WebApp.styled.js';

// Components
import MapSearch from './layouts/MapSearch/MapSearch';

const WebApp = () => {
	return (
		<ThemeProvider theme={{ ...variablesStyling, ...colorsStyling }}>
			<BodyStyled />
			<SiteWrapperStyled>
				<MapSearch />
			</SiteWrapperStyled>
		</ThemeProvider>
	);
};

export default WebApp;
